import { useEffect, useRef, useState } from 'react'

import { TAB_SCROLL_BUTTON_HIDE_DELAY } from './useTabScrollButtonVisibility.constants'

export function useTabScrollButtonVisibility(
  hideDelay = TAB_SCROLL_BUTTON_HIDE_DELAY
) {
  const [isHovered, setHovered] = useState(false)

  const [isClosing, setIsClosing] = useState(false)

  const timeoutRef = useRef(null)

  function clearTimeoutRef() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  function handleMouseEnter() {
    clearTimeoutRef()
    setIsClosing(false)
    setHovered(true)
  }

  function handleMouseLeave() {
    setHovered(false)
    setIsClosing(true)

    timeoutRef.current = setTimeout(() => {
      setIsClosing(false)
      timeoutRef.current = null
    }, hideDelay)
  }

  useEffect(() => {
    return clearTimeoutRef
  }, [clearTimeoutRef])

  return {
    handleMouseEnter,
    handleMouseLeave,
    isClosing,
    isHovered,
  }
}
